import React from 'react';
import PropTypes from 'prop-types';
import ScrollArea from 'components/scroll-area/scroll-area';
/* components */
import ModalDefault from './modal-default';

const ModalConfirm = props => (
    <ModalDefault
        className="sten-modal--with-footer"
        modalSize="xs"
        isOpen={props.isOpen}
        onRequestClose={props.onCancel}
    >
        <ScrollArea className="sten-modal__body flex flex-center">
            <div className="sten-content__section">
                {props.children}
            </div>
        </ScrollArea>
        <footer className="sten-modal__footer">
            <div className="flex-grow flex-row flex-center">
                <div className="flex-grow text-right">
                    <button onClick={props.onCancel} className="btn btn--secondary">Cancel</button>
                </div>
                <div className="flex-shrink">
                    <button onClick={props.onConfirm} className="btn btn--primary">
                        {props.confirmationButtonText ? props.confirmationButtonText : 'Confirm'}
                    </button>
                </div>
            </div>
        </footer>
    </ModalDefault>
);

ModalConfirm.propTypes = {
    children: PropTypes.node,
    confirmationButtonText: PropTypes.string,
    isOpen: PropTypes.bool,
    onCancel: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired
};

ModalConfirm.defaultProps = {
    children: null,
    confirmationButtonText: null,
    isOpen: false
};

export default ModalConfirm;
